export const APIBaseURL: string =
  process.env.REACT_APP_API_URL || "http://127.0.0.1";

export const S3Url: string = process.env.REACT_APP_S3_URL || "https://calibrate-pd-assets.s3.eu-west-2.amazonaws.com/";

export const ChatStreamerURL: string =
  process.env.REACT_APP_CHAT_STREAMER_URL ||
  "https://w67isi4xmgdkrrrzborkiqhwu40rqytu.lambda-url.eu-west-2.on.aws/";

const REACT_APP_PAGINATION_SIZE = process.env.REACT_APP_PAGINATION_SIZE || 20;
export const PAGINATION_SIZE = +REACT_APP_PAGINATION_SIZE;

export const LOGIN_URL: string = "/login";
export const REGISTER_URL: string = "/register";
export const VERIFY_EMAIL_URL: string = "/verify-email";
export const FORGOT_PASSWORD_URL: string = "/forgot-password";
export const RESET_PASSWORD_URL: string = "/reset-password";
export const CREATE_PASSWORD_URL: string = "/create-password";
export const RESEND_INVITE_URL: string = "/resend-invite";
//
export const DASHBOARD_URL: string = "/app/dashboard";
export const SELECT_TENANT_URL: string = "/app/select-tenant";
export const PEOPLE_URL: string = "/app/people";
export const PEOPLE_SHOW_URL: string = "/app/people/:userId";
export const PEOPLE_STAFF_URL: string = "/app/people/staff/:userId";
export const PEOPLE_STAFF_COMMENT_URL: string =
  "/app/people/staff/:userId/comment";
export const PEOPLE_STAFF_COMMENT_ADD_URL: string =
  "/app/people/staff/:userId/expectation/:expectationId/comment/add";
export const PEOPLE_STAFF_COMMENT_EDIT_URL: string =
  "/app/people/staff/:userId/comment/:commentId/edit";
export const INDICATOR_REQUEST_URL: string = "/app/indicators/:userId/request";
export const VALIDATIONS_URL: string = "/app/validations";
export const MEDS_URL: string = "/app/cres";
export const INDICATORS_URL: string = "/app/indicators";
export const INDICATOR_START_URL: string = "/app/indicators/start";
export const INDICATOR_VIEW_URL: string = "/app/indicators/view/:id";
export const INDICATOR_VERIFY_URL: string = "/app/indicators/validate/:id";
export const INDICATOR_PREVIOUS_URL: string = "/app/indicators/previous";
export const ACTION_PLAN_URL: string = "/app/action-plan";
export const SUGGESTED_ACTIONS_URL: string = "/app/suggested-actions/:indicatorId";
export const SETUP_URL: string = "/app/setup";
export const CHANGE_PASSWORD_URL: string = "/app/change-password";
export const COMPANY_SETUP_URL: string = "/app/setup/company";
export const AI_SETUP_URL: string = "/app/setup/ai";
export const AI_PROMPTS_URL: string = "/app/setup/ai-prompts";
export const CHATBOT_USAGE_URL: string = "/app/setup/chatbot-usage";
export const VALUES_SETUP_URL: string = "/app/setup/values";
export const RESPECT_EXPECTATIONS_SETUP_URL: string = "/app/setup/respect-expectations";
export const ROLES_SETUP_URL: string = "/app/setup/roles";
export const ROLES_CRES_URL: string = "/app/setup/roles/cres/:roleId";
export const PROFESSIONAL_STANDARDS_URL = "/app/setup/professional-standards";
export const PROFESSIONAL_STANDARDS_URL_EDIT = "/app/setup/professional-standards/:id";
export const FIXED_ACTIONS_SETUP_URL: string = "/app/setup/fixed-actions";
export const TRANSLATIONS_SETUP_URL: string = "/app/setup/translations";
export const EMAIL_TEMPLATES_SETUP_URL: string = "/app/setup/email-templates";
export const EMAIL_TEMPLATE_EDIT_URL: string = "/app/setup/email-templates/:type";
export const ACTION_PLAN_TESTER_URL: string = "/app/setup/action-plan-tester";
export const COMPETENCY_QUESTION_GENERATION_URL: string = "/app/setup/competency-questions";
export const SEED_DATA_URL: string = "/app/setup/seed-data";
export const STAFF_SETUP_URL: string = "/app/setup/staff";
export const COMPETENCY_TESTS_URL: string = "/app/competency-tests";
export const COMPETENCY_TEST_TAKE_URL: string = "/app/competency-tests/:id";
export const REPORTS_URL: string = "/app/reports";
export const SIMULATION_EXERCISE_URL: string = "/app/simulation-exercise";
export const REPORTS_COMPLIANCE_URL: string = "/app/reports/compliance";
export const REPORTS_INDICATORS_URL: string = "/app/reports/indicators";
export const REPORTS_VERIFICATION_URL: string = "/app/reports/verification";
export const REPORTS_COMPETENCY_URL: string = "/app/reports/competency";
export const REPORTS_ACTION_PLANS_URL: string = "/app/reports/action-plans";
export const REPORTS_ACTION_PLAN_REVIEWS_URL: string = "/app/reports/action-plan-reviews";
export const REPORTS_ACTION_PLAN_REVIEWS_SUMMARY_URL: string = "/app/reports/action-plan-reviews/summary";
export const REPORTS_MANAGERS_URL: string = "/app/reports/managers";
// Executive / CEO
export const REPORTS_SUPPORT_USAGE_URL: string = "/app/reports/support-usage";
// Learning & Development
export const REPORTS_TRAINING_DEMAND_URL: string = "/app/reports/training-demand";
export const REPORTS_TRAINING_EFFECTIVENESS_URL: string = "/app/reports/training-effectiveness";
export const REPORTS_WASTED_TRAINING_URL: string = "/app/reports/wasted-training";
// Human Resources
export const REPORTS_ROLE_FIT_URL: string = "/app/reports/role-fit";
export const REPORTS_PROMOTION_READINESS_URL: string = "/app/reports/promotion-readiness";
export const REPORTS_UNDERPERFORMANCE_URL: string = "/app/reports/underperformance";
// QHSSE
export const REPORTS_SAFETY_COMPETENCY_URL: string = "/app/reports/safety-competency";
export const REPORTS_AUDIT_READINESS_URL: string = "/app/reports/audit-readiness";
export const REPORTS_INCIDENT_CORRELATION_URL: string = "/app/reports/incident-correlation";
// Operations Management
export const REPORTS_MANAGER_USAGE_URL: string = "/app/reports/manager-usage";
export const REPORTS_NOTIFICATION_USAGE_URL: string = "/app/reports/notification-usage";
export const REPORTS_TEAM_IMPROVEMENT_URL: string = "/app/reports/team-improvement";
// Operations
export const REPORTS_CRE_HEATMAP_URL: string = "/app/reports/cre-heatmap";
export const REPORTS_SAFETY_EXPOSURE_URL: string = "/app/reports/safety-exposure";
export const REPORTS_ACTION_CLOSURE_URL: string = "/app/reports/action-closure";
export const REPORTS_UTILISATION_URL: string = "/app/reports/utilisation";
export const REPORTS_TEAM_GLANCE_URL: string = "/app/reports/team-glance";
// Admin
export const REPORTS_AI_USAGE_URL: string = "/app/reports/ai-usage";

// API URL
export const API_VALIDATE_TOKEN_URL: string = "/revalidate-token";

// Notifications
